import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, NavigationExtras } from '@angular/router';
import { Table } from 'primeng/table';
import { ProgramTypesGUID } from '../../../models/_enum-collections';
import { ApiResponse } from '../../../models/api-response.model';
import { EventPaymentBatchDetails } from '../../../models/event-payment-batch-details.model';
import { EventPaymentBatchEvent } from '../../../models/event-payment-batch-event.model';
import { EventPaymentBatchStatusDropDown } from '../../../models/event-payment-batch-status.model';
import { AppConstants } from '../../common/app-constants';
import { CommonService } from '../../common/common.service';
import { SettingsService } from '../../common/settings.service';
import { EventPaymentScheduleService } from '../../services/event-payment-schedule.service';
import { CommonSharedModule } from '../../common/shared.module';
import eventNewPaymentBatch from '../event-new-payment-batch-milestone2/event-new-payment-batch-milestone2.component-config.json';

@Component({
  selector: 'app-event-new-payment-batch',
  templateUrl: './event-new-payment-batch.component.html',
  styleUrls: ['./event-new-payment-batch.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class EventNewPaymentBatchComponent implements OnInit {
  @ViewChild('dt', { static: false }) dt!: Table;
  engcols!: any[];
  apires!: ApiResponse;
  msgs: any[] = [];
  collecteIdArray: any[] = [];
  collecteId!: string;
  createPaymentBatch!: EventPaymentBatchDetails;
  selectedEvents: EventPaymentBatchEvent[] = [];
  eventList: EventPaymentBatchEvent[] = [];
  paymentBatchStatus: EventPaymentBatchStatusDropDown[] = [];
  selectedEventPaymentBatchStatus!: string;
  dataViewRecsPerPage!: number;
  pageLinksPerPage!: number;
  emptyRecordMsg!: string;
  currentPageInfo!: string;
  totalRecords!: number;
  tblPageNumber!: number;
  paymentBatchForm!: FormGroup;
  clonedEvents: Record<number, EventPaymentBatchEvent> = {};
  editing = false;
  editingNav = false;
  isSpin = false;
  loading = false;
  loadingIcon = 'fa-circle-o-notch';
  showForm = true;
  disableSubmit = false;
  firstEditInitEng!: EventPaymentBatchEvent;
  editRowsCtr = 0;
  selectedProgramOption!: string;
  selectedProgramGuid!: ProgramTypesGUID;
  engagementId!: string;
  engagementName!: string;
  engagementSubType!: string;
  showTargetProduct = false;

  constructor(
    private eventPaymentScheduleService: EventPaymentScheduleService,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    public settings: SettingsService,
    public router: Router
  ) {}

  ngOnInit() {
    this.selectedProgramOption = history.state.selectedProgramOption;
    this.getEventSheduleHeaderFilelds();

    this.loading = true;
    this.editing = false;
    this.dataViewRecsPerPage = 15;
    this.pageLinksPerPage = AppConstants.dataListPagerLinks;

    this.engcols = [
      { field: 'eventId', header: 'Event ID' },
      { field: 'eventName', header: 'Event Name' },
      { field: 'eventTypeName', header: 'Event Type' },
      { field: 'eventTargetProductName', header: 'Target Product' },
      { field: 'partnerName', header: 'Partner Name' },
      { field: 'profileStatus', header: 'Profile Status' },

      { field: 'partnerPriority', header: 'Partner Priority' },
      { field: 'blockedStatus', header: 'Blocked Status' },

      { field: 'partnerLocation', header: 'Partner Location' },
      { field: 'fiscalYear', header: 'Fiscal Year' },
      { field: 'partnerId', header: 'Partner ID' },
      { field: 'payeeName', header: 'Payee Name' },
      { field: 'amount', header: 'Amount' },
      { field: 'msInvoiceNumber', header: 'MS Invoice Number' },
      { field: 'msInvoicePaidDate', header: 'MS Invoice Paid Date' },
      {
        field: 'paymentCentralTransactionId',
        header: 'Payment Central Transaction ID'
      }
    ];

    this.paymentBatchForm = this.formBuilder.group({
      paymentBatchName: [''],
      paymentBatchScheduleDate: ['', [Validators.required]],
      anticipatedPaymentDate: ['', [Validators.required]],
      actualPaymentCentralDate: [''],
      paymentBatchStatus: ['', [Validators.required]],
      selectedEvents: [''],
      amount: [''],
      partnerId: [''],
      payeeName: [''],
      contactName: [''],
      contactEmail: [''],
      emailLanguage: [''],
      accountCode: [''],
      internalOrderOrCostCenter: [''],
      currency: [''],
      netAmount: [''],
      taxAmount: [''],
      msInvoiceNumber: [''],
      msInvoicePaidDate: [''],
      paymentCentralTransactionId: ['']
    });

    this.getEventDetails();
    this.getPaymentBatchStatus();
  }

  cancelSearchNav() {
    const navigationExtras: NavigationExtras = {
      state: {
        selectedProgramOption: this.selectedProgramOption
      }
    };

    this.router.navigate(['events-payment-schedule'], navigationExtras);
  }

  selectRow(e, l) {
    const event = this.eventList.find(item => item.eventId === l.eventId);

    if (event) {
      if (e === true) {
        event.editCheckBox = true;
      } else {
        event.editCheckBox = false;
      }
    }
  }

  getEventDetails() {
    this.eventPaymentScheduleService
      .getPaymentScheduleEventDetails(this.selectedProgramGuid)
      .subscribe(evtList => {
        this.eventList = evtList;
        this.totalRecords = this.eventList.length;
        this.currentPageInfo =
          'Showing 1 - ' +
          1 * this.dataViewRecsPerPage +
          ' of ' +
          this.totalRecords +
          ' Records';
        this.loading = false;
        if (
          this.totalRecords < this.dataViewRecsPerPage &&
          this.totalRecords !== 0
        ) {
          this.currentPageInfo =
            'Showing 1' +
            ' - ' +
            this.totalRecords +
            ' of ' +
            this.totalRecords +
            ' Records';
        } else if (this.totalRecords === 0) {
          this.currentPageInfo = 'No Record Found';
          this.loading = false;
        }
      });
  }

  pageChange(e) {
    this.tblPageNumber = e.first;
    if (e.first + this.dataViewRecsPerPage > this.totalRecords) {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    } else {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        (this.tblPageNumber + this.dataViewRecsPerPage) +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  applyFilter(event) {
    this.totalRecords = event.filteredValue.length;
    if (this.totalRecords === 0) {
      this.currentPageInfo = 'No Record Found';
    }
    if (this.totalRecords > 0 && this.totalRecords > this.dataViewRecsPerPage) {
      this.currentPageInfo =
        'Showing 1 - ' +
        1 * this.dataViewRecsPerPage +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
    if (
      this.totalRecords > 0 &&
      this.totalRecords <= this.dataViewRecsPerPage
    ) {
      this.currentPageInfo =
        'Showing 1 - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  reset() {
    if (this.dt) {
      this.dt.sortField = 'eventID';
      this.dt.sortOrder = -1;

      this.dt.reset();
    }

    if (this.eventList === null || this.eventList.length === 0) {
      this.totalRecords = 0;
      this.currentPageInfo = 'No Records Found';
    } else {
      this.totalRecords = this.eventList.length;
      if (this.totalRecords > 0 && this.totalRecords > this.totalRecords) {
        this.currentPageInfo =
          'Showing 1 - ' +
          1 * this.totalRecords +
          ' of ' +
          this.totalRecords +
          ' Records';
      }

      if (this.totalRecords > 0 && this.totalRecords <= this.totalRecords) {
        this.currentPageInfo =
          'Showing 1 - ' +
          this.totalRecords +
          ' of ' +
          this.totalRecords +
          ' Records';
      }
    }
  }
  getPaymentBatchStatus() {
    this.eventPaymentScheduleService
      .getPaymentBatchStatus()
      .subscribe(statusList => {
        this.paymentBatchStatus = statusList;
      });
  }

  onSubmit() {
    this.loading = true;
    const datePipe = new DatePipe('en-US');
    const ScheduleDate = datePipe.transform(
      this.paymentBatchForm.controls['paymentBatchScheduleDate'].value,
      'MM/dd/yyyy'
    );
    const anticipatedPaymentDate = datePipe.transform(
      this.paymentBatchForm.controls['anticipatedPaymentDate'].value,
      'MM/dd/yyyy'
    );
    const actualPaymentCentralDate = datePipe.transform(
      this.paymentBatchForm.controls['actualPaymentCentralDate'].value,
      'MM/dd/yyyy'
    );

    this.createPaymentBatch = {
      events: [],
      paymentScheduleBatch: {
        paymentBatchScheduleDate: this.getDate(
          new Date(ScheduleDate || new Date())
        ).toISOString(),
        anticipatedPaymentDate: this.getDate(
          new Date(anticipatedPaymentDate || new Date())
        ).toISOString(),
        actualPaymentCentralDate:
          actualPaymentCentralDate 
            ? this.getDate(new Date(actualPaymentCentralDate)).toISOString()
            : null,
        paymentBatchStatusId:
          this.paymentBatchForm.controls['paymentBatchStatus'].value
            .eventPaymentBatchStatusId,
        paymentCentralRequestId:
          this.paymentBatchForm.controls['paymentBatchStatus'].value
            .paymentCentralTransactionId
      }
    };

    if (
      this.selectedEvents.length !== 0 ||
      this.selectedEvents.length !== undefined
    ) {
      for (const item of this.selectedEvents) {
        this.createPaymentBatch.events.push({
          eventId: item.eventId,
          eventName: item.eventName,
          partnerId: item.partnerId,
          payeeName: item.payeeName,
          contactName: item.contactName,
          contactEmail: item.contactEmail,
          emailLanguage: item.emailLanguage,
          accountCode: item.accountCode,
          internalOrderOrCostCenter: item.internalOrderOrCostCenter,
          currency: item.currency,
          amount: item.amount,
          netAmount: item.netAmount,
          taxAmount: item.taxAmount,
          msInvoiceNumber: item.msInvoiceNumber,
          msInvoicePaidDate: item.msInvoicePaidDate,
          paymentCentralTransactionId: item.paymentCentralTransactionId
        });
        const mn = this.eventList.find(it => it.eventId === item.eventId);
        const msin = mn?.msInvoiceNumber;
        if (msin !== item.msInvoiceNumber) {
          this.collecteIdArray.push(mn?.eventId);
        }
      }
    }
    if (this.selectedEvents.length === 0) {
      this.loading = false;
      this.msgs = [];
      this.msgs.push({
        severity: 'error',
        detail: 'Please select any one Event from the list'
      });
      setTimeout(() => {
        this.msgs = [];
      }, 5000);
      return;
    }

    this.createPaymentBatch.programTypeGuid = this.getProgramTypeGuid();
    this.eventPaymentScheduleService
      .createPaymentBatch(this.createPaymentBatch)
      .subscribe(
        messageResponse => {
          this.apires = messageResponse;
          this.loading = false;
          if (this.apires) {
            this.msgs = [];
            this.msgs.push({
              severity: 'success',
              detail: 'Payment Batch Created Successfully'
            });
            this.paymentBatchForm.reset();
            this.selectedEvents = [];
            setTimeout(() => {
              const navigationExtras: NavigationExtras = {
                state: {
                  selectedProgramOption: this.selectedProgramOption
                }
              };
              this.router.navigate(
                ['events-payment-schedule'],
                navigationExtras
              );
            }, 2000);
          }
          if (this.apires.success === false) {
            this.loading = false;
            this.msgs = [];
            this.msgs.push({
              severity: 'error',
              detail: this.apires.errorMessages
                ? this.apires.errorMessages[0]
                : 'Unknown error'
            });
          }
          this.showForm = false;
        },
        error => {
          this.loading = false;
          this.msgs = [];
          let errors: string[] = [];
          if (error.status === 400) {
            errors = this.commonService.getBadRequestErrors(error);
            for (const msg of errors) {
              this.msgs.push({ severity: 'warn', detail: msg });
            }
          } else {
            this.msgs.push({
              severity: 'warn',
              detail: 'Sorry an Error Occured while Creating Payment Batch'
            });
          }
          this.showForm = true;
        }
      );
  }

  onRowEditInit(event: EventPaymentBatchEvent) {
    this.clonedEvents[event.eventId || -1] = { ...event };
    this.disableSubmit = true;
    if (this.editRowsCtr === 0) {
      this.editing = true;
      this.firstEditInitEng = Object.create(event);
    }
    this.editRowsCtr++;
  }

  onRowEditSave(eng: EventPaymentBatchEvent) {
    if (eng.amount !== null) {
      delete this.clonedEvents[eng.eventId || -1];
      this.disableSubmit = false;
      eng.edited = true;
      eng.partnerId = this.firstEditInitEng.partnerId;
      eng.payeeName = this.firstEditInitEng.payeeName;
      eng.contactName = this.firstEditInitEng.contactName;
      eng.contactEmail = this.firstEditInitEng.contactEmail;
      eng.emailLanguage = this.firstEditInitEng.emailLanguage;
      eng.accountCode = this.firstEditInitEng.accountCode;
      eng.internalOrderOrCostCenter =
        this.firstEditInitEng.internalOrderOrCostCenter;
      eng.currency = this.firstEditInitEng.currency;
      eng.amount = this.firstEditInitEng.amount;
      eng.netAmount = this.firstEditInitEng.netAmount;
      eng.taxAmount = this.firstEditInitEng.taxAmount;
      eng.msInvoiceNumber = this.firstEditInitEng.msInvoiceNumber;
      eng.msInvoicePaidDate = this.firstEditInitEng.msInvoicePaidDate;
      eng.paymentCentralTransactionId =
        this.firstEditInitEng.paymentCentralTransactionId;
    }
    this.editRowsCtr--;
    if (this.editRowsCtr === 0) {
      this.editing = false;
    }
  }

  onRowEditCancel(eng: EventPaymentBatchEvent, index: number) {
    this.eventList[index] = this.clonedEvents[eng.eventId || -1];
    delete this.clonedEvents[eng.eventId || -1];
    const idx = this.selectedEvents.findIndex(e => e.eventId === eng.eventId);
    this.selectedEvents.splice(idx, 1);
    this.eventList[index].editCheckBox = false;
    this.disableSubmit = false;
    this.editRowsCtr--;
    if (this.editRowsCtr === 0) {
      this.editing = false;
    }
  }

  private getDate(date: Date): Date {
    return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
  }

  getEventSheduleHeaderFilelds() {
    this.selectedProgramGuid = this.getProgramTypeGuid();
    const programTypeConfig = eventNewPaymentBatch.program.find(
      obj => obj.programTypeGuid === this.selectedProgramGuid
    );
    this.engagementId =
      programTypeConfig?.element.find(
        obj => obj.id === 'engagementRegistrationId'
      )?.displayName || '';
    this.engagementName =
      programTypeConfig?.element.find(obj => obj.id === 'engagementName')
        ?.displayName || '';
    this.engagementSubType =
      programTypeConfig?.element.find(obj => obj.id === 'engagementSubType')
        ?.displayName || '';
  }

  getProgramTypeGuid() {
    if (history.state.programTypeGuid) return history.state.programTypeGuid;
    else if (localStorage.getItem('programTypeGuid')) {
      const guid = localStorage.getItem('programTypeGuid');
      return guid as ProgramTypesGUID;
    } else return ProgramTypesGUID.Events;
  }
}
